import { render, staticRenderFns } from "./ActionMenuButton.vue?vue&type=template&id=59b294ef&scoped=true"
import script from "./ActionMenuButton.vue?vue&type=script&lang=ts"
export * from "./ActionMenuButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b294ef",
  null
  
)

export default component.exports